import * as yup from 'yup';
import { useTranslations } from 'hooks/useTranslations';
import { ERegExpTypes } from 'constants/RegExpTypes';
import { EOrganisationCategory } from 'constants/OrganisationCategory';

const useUserFormSchema = (isWeaponLicence: boolean) => {
  const { t } = useTranslations();
  const schema = yup
    .object({
      email: yup
        .string()
        .email(t('addUser.email.validation.incorrect'))
        .required(t('addUser.email.validation.required'))
        .matches(
          new RegExp(ERegExpTypes.email),
          t('general.field.validation.valueIsNotCorrect'),
        )
        .max(254, t('general.field.validation.maxCharacters').replace('{0}', '254'))
        .trim(),
      firstName: yup
        .string()
        .required(t('general.field.validation.required'))
        .max(100, t('general.field.validation.maxCharacters').replace('{0}', '100'))
        .trim(),
      lastName: yup
        .string()
        .required(t('general.field.validation.required'))
        .max(100, t('general.field.validation.maxCharacters').replace('{0}', '100'))
        .trim(),
      phoneNumberCodeDictionaryUniqueId: yup
        .string()
        .required(t('general.field.validation.required'))
        .trim(),
      phoneNumberValue: yup
        .string()
        .required(t('general.field.validation.required'))
        .matches(
          new RegExp(ERegExpTypes.onlyDigits),
          t('general.field.validation.valueIsNotCorrect'),
        )
        .max(15, t('general.field.validation.maxNumberCharacters').replace('{0}', '15'))
        .min(5, t('general.field.validation.minNumberCharacters').replace('{0}', '5'))
        .trim(),
      formRoleIds: yup.object(),
      formPrefixGroupIds: yup.object(),
      formOrganisationCategoryIds: yup.object(),
      formWeaponLicencingAuthority: yup.string(),
    })
    .test('roleTest', '', (obj) => {
      const anyChoosen = Object.values(obj.formRoleIds).filter(Boolean).length;
      return anyChoosen > 0
        ? true
        : new yup.ValidationError(t('general.field.validation.required'), null, 'formRoleIds');
    })
    .test('prefixTest', '', (obj) => {
      const prefixChoosen = Object.keys(obj?.formPrefixGroupIds).some(
        // @ts-expect-error: required by update
        (key) => obj?.formPrefixGroupIds?.[key] === true,
      );
      const orgCategoryChoosen =
        // @ts-expect-error: required by update
        obj?.formOrganisationCategoryIds?.[EOrganisationCategory.state] === true;
      if (prefixChoosen || orgCategoryChoosen) {
        return true;
      }
      return new yup.ValidationError(
        t('addUser.formPrefixGroupIds.validation.required'),
        null,
        'formPrefixGroupIds',
      );
    })
    .test('formWeaponLicencingAuthorityTest', '', (obj) => {
      if (obj.formWeaponLicencingAuthority || !isWeaponLicence) {
        return true;
      }
      return new yup.ValidationError(
        t('general.field.validation.required'),
        null,
        'formWeaponLicencingAuthority',
      );
    });

  return { schema };
};

export default useUserFormSchema;
